export function CVMonogram({ size = 80, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="cv-monogram"
    >
      {/* C letterform */}
      <path
        d="M58 16C34.8 16 16 34.8 16 58C16 81.2 34.8 100 58 100C68.5 100 78 96 85 89.5"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      {/* V letterform */}
      <path
        d="M52 32L75 92L98 32"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function CVWordmark({ className = '' }) {
  return (
    <div className={`cv-wordmark-logo ${className}`} data-testid="cv-wordmark-logo">
      <CVMonogram size={48} />
      <div className="cv-wordmark-text">
        <span className="cv-wordmark-top">Civic</span>
        <span className="cv-wordmark-bottom">Ventures</span>
      </div>
    </div>
  );
}

export function CVLockup({ className = '' }) {
  return (
    <div className={`cv-lockup ${className}`} data-testid="cv-lockup">
      <CVMonogram size={100} />
      <div className="cv-lockup-divider" />
      <div className="cv-lockup-text">
        <span className="cv-lockup-name">Civic Ventures</span>
        <span className="cv-lockup-sub">Venture Studio &amp; Strategic Consultancy</span>
      </div>
    </div>
  );
}
